// QMTrendingTiles.js
import React from "react";
import {
    FaClipboardCheck,
    FaChartLine,
    FaExclamationTriangle,
} from "react-icons/fa";
import Tools from "../utils/Tools";

function QMTrendingTiles({ qmData, totalCalls }) {
    const tiles = [
        {
            Icon: FaClipboardCheck,
            title: "Total Calls",
            value: Tools.formatNumber(totalCalls || 0),
            color: "usan-primary",
        },
        {
            Icon: FaChartLine,
            title: "Average QM Score",
            value: qmData.avgQMScore || qmData.avgQMScore === 0 ? `${(qmData.avgQMScore * 100).toFixed(1)}%` : "N/A",
            color: "usan-primary",
        },
        {
            Icon: FaExclamationTriangle,
            title: "Average Autofail Rate",
            value: qmData.avgQMAutofailRate || qmData.avgQMAutofailRate === 0 ? `${(qmData.avgQMAutofailRate * 100).toFixed(1)}%` : "N/A",
            color: "usan-primary",
        },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {tiles.map((tile, index) => (
                <div
                    key={index}
                    className={`usan-primary text-white p-4 rounded-xl shadow-lg flex items-center justify-between h-24 transition-all duration-300 hover:shadow-xl hover:scale-105`}
                >
                    <div className="flex flex-col items-start flex-grow">
                        <h3 className="text-sm font-semibold uppercase tracking-wide mb-2 opacity-90">
                            {tile.title}
                        </h3>
                        <div className="flex items-center">
                            <p className="text-3xl font-bold">{tile.value}</p>
                        </div>
                    </div>
                    <tile.Icon className="text-5xl opacity-70 ml-4" />
                </div>
            ))}
        </div>
    );
}

export default QMTrendingTiles;